/**
 * Contains all the labels/text required to create dialogs
 */
export const PROMPTS = {
  TEXT: {
    IS_REQUIRED: $localize`:text:is required`,
    ARE_REQUIRED: $localize`:text:are required`,
    MIN_LENGTH: $localize`:text:Minimum 6 tags are required. Please add more tags.`,
    MULTI_VALUE: $localize`Multiple values`,
  },
  LABELS: {
    YES: $localize`:button:Yes`,
    NO: $localize`:button:No`,
    OK: $localize`:button:Ok`,
    NEXT: $localize`:button:Next`,
    BACK: $localize`:button:Back`,
    SUBMIT: $localize`:button:Submit`,
  },
  PLACEHOLDER: {
    SEARCH: $localize`:placeholder:Search`,
    EMPTY_OPTION: $localize`:placeholder:— None —`,
    DROPDOWN_SELECT_ONE: $localize`:placeholder:-- Select One --`,
    DROPDOWN_SELECT_MULTIPLE: $localize`:placeholder:-- Select Multiple --`,
    DROPDOWN_SELECT_ALL: $localize`:placeholder:-- Select All --`,
  },
  PROJECT: {
    CLOSE: {
      TITLE: $localize`Close Project`,
      MESSAGE: $localize`Are you sure you want to close this project?`,
      FAILED: {
        TITLE: $localize`Close Project Failed`,
      },
    },
    DELETE: {
      TITLE: $localize`Delete Project`,
      MESSAGE: $localize`Are you sure you want to delete this project?`,
      FAILED: {
        TITLE: $localize`Delete Project Failed`,
      },
    },
    REOPEN: {
      TITLE: $localize`Reopen Project`,
      MESSAGE: $localize`Are you sure you want to re-open this project? Please adjust project timing when re-opening.`,
      FAILED: {
        TITLE: $localize`Reopen Project Failed`,
      },
    },
  },
  TASK: {
    CLOSE_ALL: {
      TITLE: $localize`Close All Tasks`,
      MESSAGE: $localize`Are you sure you want to close all tasks?`,
    },
  },
};
